"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGeocodingSearch = void 0;
var _auth = require("@ori/auth");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _react = require("react");
var _maps = require("../../constants/maps");
var _usePickupPointsSearchConfiguration = require("../../hooks/usePickupPointsSearchConfiguration");
var _logger = require("../../logger");
var _utils = require("./utils");
const hookName = 'useGeocodingSearch';
const useGeocodingSearch = () => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    formattedToken
  } = (0, _auth.useToken)();
  const [fetcherModule, setFetcherModule] = (0, _react.useState)();
  const [isFetcherModuleLoading, setIsFetcherModuleLoading] = (0, _react.useState)(false);
  const pickupPointsSearchConfiguration = (0, _usePickupPointsSearchConfiguration.usePickupPointsSearchConfiguration)();
  const {
    mapConfiguration: {
      account: mapAccount = {},
      provider: mapType = undefined
    } = {},
    viewSettings,
    setViewSettings
  } = pickupPointsSearchConfiguration;
  const isActive = mapType === undefined ? false : _maps.SUPPORTED_GEOCODING_PROVIDERS.includes(mapType);
  if (isActive && mapType !== undefined && !fetcherModule && !isFetcherModuleLoading) {
    setIsFetcherModuleLoading(true);
    (0, _logger.logDebug)(`${hookName} hook: Supported map provider found, data fetcher has to be loaded.`);
    void (0, _utils.getFetcherModule)(mapType, setIsFetcherModuleLoading, setFetcherModule);
  }
  const {
    basePath = '',
    fetchData: fetcher,
    getQueryParams,
    host
  } = fetcherModule ?? {};
  const searchByGeocoding = async ({
    searchTerm,
    maxResultsCount
  }) => {
    const queryParams = getQueryParams ? getQueryParams(searchTerm, {
      mapAccount,
      tenant,
      maxResultsCount
    }) : {};
    const urlOptions = (0, _utils.getGeocodingSearchUrlOptions)({
      basePath,
      currentLanguage: language,
      formattedToken,
      tenant,
      host,
      queryParams
    });
    const result = await fetcher?.(urlOptions);
    (0, _logger.logDebug)(`${hookName} - searchByGeocoding finished successfully. Loaded data:`, result);
    const location = (0, _utils.getLocationFromGeocodingSearchResult)(result);
    if (location) {
      setViewSettings({
        location,
        zoom: viewSettings.zoom
      });
    }
  };
  return {
    searchByGeocoding
  };
};
exports.useGeocodingSearch = useGeocodingSearch;